import _ from 'underscore';

import { ApiPlugin } from './api-plugins';
import { reportError } from '../helpers/common';

/**
 * Check if Sentry error reporting is enabled.
 */
function isEnabled() {
  return window.$sentry !== undefined;
}

/**
 * Convert URLSearchParams to JS object.
 */
function collectParams(params) {
  const obj = {};
  for (const key of params.keys()) {
    if (params.getAll(key).length > 1) {
      obj[key] = params.getAll(key);
    } else {
      obj[key] = params.get(key);
    }
  }
  return obj;
}

/**
 * Sentry Error Reporting plugin
 */
class SentryErrorsPlugin extends ApiPlugin {
  static before(config) {
    if (!isEnabled()) {
      return;
    }
    try {
      throw new Error('');
    } catch (e) {
      config.extraStack = e.stack;
    }
  }

  static after(res, config, error) {
    if (!isEnabled() || !error || (error.response && error.response.status === 401)) {
      return;
    }

    // if http error code is in ignore list then do not raise sentry alert
    const httpCodesToIgnore = config.ignoreHttpCodes || [];
    if (error.response && httpCodesToIgnore.includes(error.response.status)) {
      return;
    }

    // update the message with extra info about the request (method, url and params)
    if (error.response && error.response.data && error.response.data.message) {
      error.message += ` - ${error.response.data.message}`;
    }
    error.message += `\n${config.method.toUpperCase()} ${config.url}`;

    // add request data, if present
    let data;
    if (config.method === 'get') {
      data = config.params;
    } else {
      // eslint-disable-next-line prefer-destructuring
      data = config.data;
    }
    if (data && _.isObject(data)) {
      error.message += `\n${JSON.stringify(data)}`;
    }
    if (error.response && error.response.data) {
      error.message += `\nResponse: ${JSON.stringify(error.response.data)}`;
    }

    // append extra stack info, if available
    if (config.extraStack !== undefined) {
      error.stack += `\n${config.extraStack}`;
    }

    reportError(error);
  }
}

export default SentryErrorsPlugin;
